// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { accountSettingsDefaultBillingShippingStyles } from "@insite/content-library/Widgets/AccountSettings/AccountSettingsDefaultBillingShipping";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { screen } from "@rugby/XDL/Helpers";
import { css } from "styled-components";

const headingText = {
    css: css`
        font-size: 22px;
        margin-bottom: 5px;
        display: block;
        line-height: 32px;
    `,
} as InjectableCss;

accountSettingsDefaultBillingShippingStyles.defaultBillingShippingTitle = {
    ...accountSettingsDefaultBillingShippingStyles.defaultBillingShippingTitle,
    css: css`
        ${accountSettingsDefaultBillingShippingStyles.defaultBillingShippingTitle?.css}
        width: calc(100% + 50px);
        & ~ div {
            div[class^="GridOffset"] {
                width: auto;
            }
        }
    `,
};
accountSettingsDefaultBillingShippingStyles.headingText = headingText;

accountSettingsDefaultBillingShippingStyles.pickUpLocation = {
    ...accountSettingsDefaultBillingShippingStyles.pickUpLocation,
    gridContainer: {
        ...accountSettingsDefaultBillingShippingStyles.pickUpLocation?.gridContainer,
        css: css`
            ${screen("lte", "sm")`
                margin-bottom: 20px;
            `}
        `,
    },
    headerText: {
        css: css`
            ${headingText.css}
        `,
    },
    changeLink: {
        css: css`
            display: none;
        `,
    },
};

accountSettingsDefaultBillingShippingStyles.defaultShippingRadioGridItem = {
    width: 12,
    css: css`
        ${accountSettingsDefaultBillingShippingStyles.defaultShippingRadioGridItem?.css}
        &&& {
            margin-bottom: 20px;
            ${screen("lte", "sm")`
                margin-top: 10px;
            `}
        }
    `,
};

accountSettingsDefaultBillingShippingStyles.customerSelectorGridItem = {
    ...accountSettingsDefaultBillingShippingStyles.customerSelectorGridItem,
    css: css`
        ${accountSettingsDefaultBillingShippingStyles.customerSelectorGridItem?.css}
        &&& {
            margin-bottom: 20px;
        }
    `,
};

accountSettingsDefaultBillingShippingStyles.defaultFulfillmentMethodRadioGridItem = {
    ...accountSettingsDefaultBillingShippingStyles.defaultFulfillmentMethodRadioGridItem,
    css: css`
        ${accountSettingsDefaultBillingShippingStyles.defaultFulfillmentMethodRadioGridItem?.css}
        &&& {
            margin-bottom: 20px;
        }
    `,
};
